import { Money04Icon } from "@hugeicons-pro/core-stroke-rounded";
import { formatAddress } from "shared/utils";
import { formatToCurrency } from "shared/utils/currency";
import { Section } from "views/applications-id-report/components/Section";
import { Row } from "views/applications-id-report/components/Row";
import { SectionIcon } from "../components/SectionIcon";
import { PurchaseInfo } from "../types";
import { formatLabel } from "../utils";

export const LoanDetailsSlice = ({ loan }: { loan: PurchaseInfo }) => {
  const propertyAddress = loan.propertyAddressKnown
    ? formatAddress({
        street: loan.propertyStreet,
        city: loan.propertyCity,
        state: loan.propertyState,
        zip: loan.propertyZip
      })
    : "Not yet selected";

  return (
    <Section
      sectionTitle="Loan details"
      icon={<SectionIcon icon={Money04Icon} />}
    >
      <div className="space-y-2">
        <Row
          title="Purchase price"
          value={formatToCurrency(loan.purchasePrice)}
        />
        <Row
          title="Down payment"
          value={formatToCurrency(loan.downPaymentAmount)}
        />
        <Row title="Loan amount" value={formatToCurrency(loan.loanAmount)} />
        <Row title="Loan program" value={formatLabel(loan.loanProgram)} />
        <Row title="Usage type" value={formatLabel(loan.propertyUsageType)} />
        <Row title="Property address" value={propertyAddress} />
      </div>
    </Section>
  );
};
